import { useEtcTickets } from '../etc/endpoints/ticketsHooks';
import { useHighwayMaintenanceFeeTickets } from '../highway-maintenance-fee/endpoints/ticketsHooks';
import { useCompulsoryInsurancePenaltyTickets } from '../compulsory-insurance-penalty/endpoints/ticketsHooks';
import { useHighwayMaintenanceFeePenaltyTickets } from '../highway-maintenance-fee-penalty/endpoints/ticketsHooks';
import { TICKET_TYPE } from '../config';
import { EtcTicketState } from '../etc/model';
import { HighwayMaintenanceFeeTicketState } from '../highway-maintenance-fee/model';
import { CompulsoryInsurancePenaltyTicketState } from '../compulsory-insurance-penalty/model';
import { HighwayMaintenanceFeePenaltyTicketState } from '../highway-maintenance-fee-penalty/model';

export interface TicketCountsStates {
  etc: EtcTicketState[];
  hmf: HighwayMaintenanceFeeTicketState[];
  cip: CompulsoryInsurancePenaltyTicketState[];
  hmfp: HighwayMaintenanceFeePenaltyTicketState[];
}

export function useTicketCounts(
  states: TicketCountsStates,
): Record<TICKET_TYPE, number> {
  const etc = useEtcTickets({ state: states.etc });
  const hmf = useHighwayMaintenanceFeeTickets({ state: states.hmf });
  const cip = useCompulsoryInsurancePenaltyTickets({ state: states.cip });
  const hmfp = useHighwayMaintenanceFeePenaltyTickets({ state: states.hmfp });

  return {
    [TICKET_TYPE.ETC_TICKETS]: etc.data?.data.length ?? 0,
    [TICKET_TYPE.HIGHWAY_MAINTENANCE_FEE_TICKETS]: hmf.data?.data.length ?? 0,
    [TICKET_TYPE.COMPULSORY_INSURANCE_PENALTY_TICKETS]:
      cip.data?.data.length ?? 0,
    [TICKET_TYPE.HIGHWAY_MAINTENANCE_FEE_PENALTY_TICKETS]:
      hmfp.data?.data.length ?? 0,
  };
}
